import { useNavigationManager } from '@provider/navigation';
import { useUserIdentityState } from '@provider/user-identity';
import { useChangeEffect } from '@utils/react';
import { useOpgavekompleksetEntry, useCurrentTaskEntryId } from './hook.entry.js';

/**
 * NB: Routing is not handled through the URL, but instead handled in memory
 * based on the current entry.
 *
 * The location is however updated to ensure that integrations can respond to
 * page changes.
 */
function useCurrentLocation() {
  const navigator = useNavigationManager();
  const ownerId = useOpgavekompleksetEntry({
    select: entry => entry?.envelope.userID
  });
  const user = useUserIdentityState(state => state.user);
  const userOwnsEntry = !user || user.id === ownerId;
  const hasFinsihedEntry = useOpgavekompleksetEntry({
    select: entry => entry?.envelope.result?.status === "completed"
  });
  const currentTaskEntryId = useCurrentTaskEntryId();
  const pageIdent = !userOwnsEntry || hasFinsihedEntry ? "results" : "input";
  useChangeEffect(() => {
    navigator.replace(`/?page=${pageIdent}&task=${currentTaskEntryId}`);
  }, [currentTaskEntryId, navigator, pageIdent]);
  return pageIdent;
}

export { useCurrentLocation };
//# sourceMappingURL=hook.location.js.map
